import { SessionExtra } from "Components/SessionChatComponent/SessionExtra/SessionExtra";
import styles from "./index.module.css";
import chatCircleSlash from "assets/svg/ChatCircleSlash.svg";
import { formatChatSeparatorDate } from "helpers/format";

type Props = {
  messageId: number;
  content: { content: any; link: string }[];
  takenInfo: {
    takenAt?: string;
    closedAt?: string;
    takenByAdminId?: string;
    closedByAdminId?: string;
  };
};

export const SessionMessage = ({ content, messageId, takenInfo }: Props) => {
  const takenAt = formatChatSeparatorDate(takenInfo?.takenAt);
  const closedAt = formatChatSeparatorDate(takenInfo?.closedAt);
  const dates = `${takenAt}${closedAt ? `- ${closedAt}` : ""}`;
  const takenBy = `${takenInfo?.takenByAdminId?.slice(0, 7)}${
    takenInfo?.closedByAdminId ? `- ${takenInfo?.closedByAdminId?.slice(0, 7)}` : ""
  }`;
  return (
    <div className={styles.systemSessionClass} id={`message-${messageId}`}>
      <div>
        <img src={chatCircleSlash} alt="chat closed" /> <span>{content[0].content}</span>
      </div>
      <SessionExtra
        dates={dates}
        messageId={messageId.toString()}
        supportId={takenInfo?.takenByAdminId ? takenBy : null}
        className={styles.messageSession}
      />
    </div>
  );
};
